import { render } from "./profile-onboarding.vue?vue&type=template&id=5c64bfbd&scoped=true"
import script from "./profile-onboarding.vue?vue&type=script&lang=js"
export * from "./profile-onboarding.vue?vue&type=script&lang=js"

import "./profile-onboarding.vue?vue&type=style&index=0&id=5c64bfbd&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c64bfbd"]])

export default __exports__